var Questionnaire = function () {
    var self = {
        selectors: {
            closeBtn: "a[data-action=close-questionnaire]",
            spinner: ".spinner",
            closeIcon: ".close-icon",
        },
        init: function () {
            $(self.selectors.closeBtn).click(function () {
                $(this).attr('disabled', true);
                $(this).find(self.selectors.closeIcon).hide();
                $(this).find(self.selectors.spinner).show();

                let url = $(this).attr('data-url');

                if (typeof url === 'undefined') {
                    return;
                }

                $.ajax({
                    type: "POST",
                    url: url,
                }).done(function (response, textStatus, jqXHR) {
                    $('#questionnaireModal').hide();
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    console.error(
                        "The following error occurred: " +
                        textStatus, errorThrown
                    );
                }).always(function () {
                    $(this).attr('disabled', false);
                    $(this).find(self.selectors.closeIcon).show();
                    $(this).find(self.selectors.spinner).hide();
                });
            });
        },
    };
    return {
        init: function () {
            self.init();
        }
    }
}();

$(document).ready(function () {
    Questionnaire.init();
});